<div class="pessoa-contato-table">
    <table class="table table-striped table-hover" [id]="idTable">
        <thead>
            <tr>
                <th class="col-options"></th>
                <th class="col-tipo-primario text-center">Primario?</th>
                <th class="col-tipo-sequencia-primario text-center">Sequência Primario</th>
                <th class="col-situacao text-center">Situação</th>
                <th class="col-tipo">Tipo</th>
                <th class="col-nome">Nome</th>
                <th class="col-fone">Telefone</th>
                <th class="col-celular">Celular</th>
                <th class="col-email">E-mail</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let entity of entities; let index = index">
                <td class="col-options">
                    <a (click)="edit.emit(index)" title="Editar Contato">
                        <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                    </a>
                    <a (click)="delete.emit(index)" title="Excluir Contato" *ngIf="canDelete(entity)">
                        <i class="far fa-trash-alt" aria-hidden="true"></i>
                    </a>
                    <a (click)="ativar.emit(index)" title="Ativar Contato" *ngIf="canAtivar(entity)">
                        <i class="fas fa-phone" aria-hidden="true"></i>
                    </a>
                    <a (click)="inativar.emit(index)" title="Inativar Contato" *ngIf="canInativar(entity)">
                        <i class="fas fa-phone-slash" aria-hidden="true"></i>
                    </a>
                </td>
                <td class="col-tipo-primario text-center">{{entity.tipo | pessoaContatoTipoPrimario}}</td>
                <td class="col-tipo-sequencia-primario text-center">{{entity.tipo | pessoaContatoTipoSequenciaPrimario}}</td>
                <td class="col-situacao text-center">
                    <span class="{{entity.situacao | pessoaContatoSituacaoBadge}}">
                        <i class="{{entity.situacao | pessoaContatoSituacaoIcon}}"></i> {{entity.situacao | pessoaContatoSituacao}}
                    </span>
                </td>
                <td class="col-tipo">{{entity.tipo | pessoaContatoTipo}}</td>
                <td class="col-nome">{{entity.nome}}</td>
                <td class="col-fone">{{entity.fone}}</td>
                <td class="col-celular">{{entity.celular}}</td>
                <td class="col-email">{{entity.email}}</td>
            </tr>
        </tbody>
    </table>
</div>

